import { Drawer } from "antd";
import "styles/antDDrawer/antDdrawer.css";

function AntDDrawer({ onClose, open, title = "", children, bgColor }: any) {
  return (
    <>
      <Drawer
        title={title}
        placement={"right"}
        width={500}
        onClose={onClose}
        open={open}
        style={{
          backgroundColor: `${bgColor ? bgColor : "var(--Color1E1E1E)"}`,
        }}
      >
        <div className="">{children}</div>
      </Drawer>
    </>
  );
}

export default AntDDrawer;
